<div class="card">
  <div class="d-flex align-items-center justify-content-between bg-white card-body"  >
    <a href="javascript:void(0)" class="text-dark" (click)="hide = !hide">Filter</a> &nbsp;
    <a href="javascript:void(0)" (click)="hide = !hide"><i class="fas fa-chevron-down text-dark" style="transition: all 0.3s ease-out; transform-origin: top;"  [style.transform]="!hide? 'rotate(180deg) translate(0, -50%)' : ''"></i></a>
  </div>
  <hr class="p-0 m-0" *ngIf="!hide">
  <div class="d-flex align-items-center justify-content-between bg-white card-body" *ngIf="hasHeader && !hide">
    <span class="d-flex align-items-center pr-2 ">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{titolo | translate}}</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
      <ng-container *ngFor="let badge of environment.ProgettiAddon['badges']">
      <ng-container   *ngIf="(badges[badge.oggetti[0]] ?? 0) >0">
        &nbsp;
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{ badge.nome | translate}}</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{this.badges[badge.oggetti[0]] }}</span>
    </ng-container>
    </ng-container>
    </span>


    <div class="buttonDiv d-flex justify-content-end" >
      <button type="button" class="btn btn-cyan rounded-pill py-2" *ngIf="permission.isPermitted('gestione-progetti') && !environment.ProgettiAddon['hideAdd']" (click)='add()'>
        <i class="fas fa-plus  font-14 mr-1 text-white"></i>
        <span class="ml-1 text-white font-weight-bold"> Aggiungi </span>
      </button>
      <ng-container *ngIf="environment.ProgettiAddon['PulsantiLista']">
        <ng-container *ngFor="let button of environment.ProgettiAddon['PulsantiLista']">
          <button type="button" [ngClass]="button['class']" *ngIf="permission.HasCapacity(button['capacita']) && (button['stato']?.includes(stato) ?? true)" (click)='customButton(button)'>
            <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
            <span [ngClass]="button['labelClass']"> {{button['nome'] | translate}} </span>
          </button>
        </ng-container>
      </ng-container>
    </div>

  </div>
  <div class="d-md-flex align-items-center border-top bg-white p-3 " *ngIf="!hide">
    <div class="input-group">

      <div class="col-lg-12"></div>
      <div class="col-lg-3">
        <label class="control-label col-form-label">Cerca per periodo:</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <label class="input-group-text" for="inizio">Inizio</label>
          </div>
          <input [(ngModel)]="filter.inizio" (ngModelChange)="Search()" id="inizio" type="date" name="inizio" class="form-control">
        </div>
      </div>
      <div class="col-lg-3">
        <label class="control-label col-form-label">&nbsp;</label>
        <div class="input-group ">
          <div class="input-group-prepend">
            <label class="input-group-text" for="fine">Fine</label>
          </div>
          <input [(ngModel)]="filter.fine" (ngModelChange)="Search()" type="date" id="fine" class="form-control">
          <div class="input-group-append">
            <div class="input-group-text">
              <div>
                <input [(ngModel)]="filter.periodo" (ngModelChange)="Search()" type="checkbox" id="periodo">
                <label for="periodo"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
        <label class="control-label col-form-label">Visualizza:</label>
        <div class="input-group ">
          <div class="input-group-prepend ">
            <label class="input-group-text" for="size">Elementi</label>
          </div>
          <select id="size" class="custom-select" (change)="sizeChanged()"
                  [ngClass]="{ 'is-invalid': submitted && f.size.errors }">
            <option value="1">1</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option selected value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
          <div *ngIf="submitted && f.size.errors" class="invalid-feedback">
            <div *ngIf="f.size.errors.required">Campo richiesto</div>
          </div>
        </div>
      </div>
      <div class="col-lg-2" *ngIf="environment.ProgettiAddon['Revisioni']">
              <label class="control-label col-form-label">&nbsp;</label>
        <div class="input-group "  >
          <div class="input-group-prepend">
            <label class="input-group-text" for="cliente">{{'Offerta.oldrev' | translate}}</label>
          </div>
          <input [(ngModel)]="filter.oldrev" (ngModelChange)="Search()" type="checkbox"  name="cliente" class="form-control">
        </div>

      </div>
      <div class="col-lg-2" *ngIf="!stato">
        <label class="control-label col-form-label">Stato:</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Seleziona'" name="categorie" [data]="stati" [(ngModel)]="statiSelezionati" (ngModelChange)="Search()">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-9">
        <!--      <label class="control-label col-form-label">&nbsp;</label>-->
        <div class="input-group " *ngIf="!cliente" style="margin-bottom: 10px; margin-top: 5px;">
          <div class="input-group-prepend">
            <label class="input-group-text" for="cliente">Azienda</label>
          </div>
          <input [(ngModel)]="filter.cliente" (ngModelChange)="Search()" type="text" id="cliente" name="cliente" class="form-control">
        </div>
      </div>

      <ng-container *ngFor="let campo of environment.ProgettiAddon['filters']">
        <div [ngClass]="campo.class" [ngStyle]="campo.style" >
          <div class="input-group " style="margin-bottom: 10px; margin-top: 5px;">
            <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
              <ng-container *ngIf="campo.type != 'object' && campo.inputType && campo.inputType != 'checkbox'">
                <div class="input-group-prepend">
                  <label class="input-group-text" >{{campo.nome | translate}}</label>
                </div>
                <input [type]="campo.inputType" [(ngModel)]="filter[oggetto]" (ngModelChange)="Search()" class="form-control"> &nbsp;
              </ng-container>
              <ng-container *ngIf="campo.type != 'object' && campo.inputType && campo.inputType == 'checkbox'">
                <div class="input-group-prepend">
                  <label class="input-group-text" >{{campo.nome | translate}}</label>
                </div>
                <input type="checkbox" [(ngModel)]="filter[oggetto]" (ngModelChange)="Search()" class="form-control"> &nbsp;
              </ng-container>
              <ng-template [ngIf]="campo.type == 'object'  &&  filter[oggetto]">
                <div class="input-group-prepend">
                  <label class="input-group-text">{{campo.nome | translate}}</label>
                </div>
                <input [type]="campo.inputType"  [(ngModel)]="filter[oggetto][campo.field[i]]" (ngModelChange)="Search()"  class="form-control"> &nbsp;
              </ng-template>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <!--  <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">-->
    <!--    <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="Search()"-->
    <!--      type="button">Cerca</button>-->
    <!--  </div>-->
  </div>
</div>

<div class="card" *ngIf="environment?.ProgettiAddon['ColoriLista']">
  <div class="card-body d-flex align-items-center">
    <div class="d-flex align-items-center" *ngFor="let colore of environment?.ProgettiAddon['ColoriLista']">
      &nbsp;
      <span style="height: 10px;width: 10px;background-color: #bbb;border-radius: 50%;display: inline-block;" [ngStyle]="{'background-color': colore.colore}"></span>
     &nbsp;
      <span class="font-14 font-weight-bold" >{{colore.label}}</span>&nbsp;
    </div>
  </div>
</div>

<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 ">
    <thead>
      <tr>
        <th (click)="Filtra('orderByCodice')">
          {{'Offerta.Codice' | translate}} &nbsp; <i *ngIf="filter.orderByCodice" class = "fas" [class.fa-caret-up]= "filter.orderByCodice == 'asc'" [class.fa-caret-down]= "filter.orderByCodice == 'desc'"></i>
        </th>
        <th *ngIf="environment.ProgettiAddon['gestore']">
          Gestore &nbsp;
        </th>
        <th scope="col" (click)="Filtra('orderByCliente')">
          Cliente &nbsp; <i *ngIf="filter.orderByCliente" class = "fas" [class.fa-caret-up]= "filter.orderByCliente == 'asc'" [class.fa-caret-down]= "filter.orderByCliente == 'desc'"></i>
        </th>
        <th scope="col" (click)="Filtra('orderByData')">
          {{'Offerta.Creazione' | translate}}&nbsp; <i *ngIf="filter.orderByData" class = "fas" [class.fa-caret-up]= "filter.orderByData == 'asc'" [class.fa-caret-down]= "filter.orderByData == 'desc'"></i>
        </th>
        <th scope="col" >
          {{'Offerta.Offerta' | translate}}
        </th>
        <th scope="col">
          {{'Offerta.Accettazione' | translate}}
        </th>
        <th (click)="Filtra('orderByName')">
          Oggetto &nbsp; <i *ngIf="filter.orderByName" class = "fas" [class.fa-caret-up]= "filter.orderByName == 'asc'" [class.fa-caret-down]= "filter.orderByName == 'desc'"></i>
        </th>
        <th scope="col" *ngIf="hasManager()" >{{'Offerta.Responsabile' | translate}}</th>
        <th scope="col" *ngIf="environment.ProgettiAddon['lavorato']">Lavorato</th>
        <th scope="col" [style]="campo.titleStyle" [class]="campo.titleClass" *ngFor="let campo of environment.ProgettiAddon['CampiAggiuntiviLista']">{{ campo.nome | translate }}</th>
        <th scope="col" *ngIf="permission.isPermitted('gestione-progetti')">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of Progetti | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td class="align-middle position-relative" (click)='edit(item)'>
          <span class="badge badge-pill px-3   font-14" [ngStyle]="{'color': LightenColor(BadgeColor(item)), 'background-color': BadgeColor(item)}">
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i class="mdi mdi-barcode-scan"></i>-->
<!--            </span>-->
            <i class="fas fa-exclamation-triangle text-warning" [ngbTooltip]="'Necessario OK amministrativo'" *ngIf="item.clienteObject.checkAmm"></i>
            {{item.codiceOrdine ? item.codiceOrdine +'('+ item.codice+')' : (item.codiceContratto?.length>0 ? item.codiceContratto : item.codice) }} <ng-container *ngIf="environment.ProgettiAddon['Revisioni'] && item?.rev > 0">Rev. {{item.rev}}</ng-container>
          </span>
        </td>
        <td class="align-middle" (click)="edit(item)" *ngIf="environment.ProgettiAddon['gestore']">
          {{item.gestoreNome}}
        </td>
        <td class="align-middle" (click)='edit(item)'>
          <i class="fas fa-exclamation-triangle text-warning" [ngbTooltip]="'Necessario OK amministrativo'" *ngIf="item.clienteObject.checkAmm"></i> &nbsp;
          <span class="badge badge-pill px-3   font-14" >{{ item.clienteObject.nominativo }}</span>
        </td>
        <td class="align-middle" (click)='edit(item)'>
          <span>
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i class="fas fa-calendar-plus"></i>-->
<!--            </span>-->
              {{ item.data_creazione | date: 'dd/MM/yyyy'}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(item)'>
          <span>
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i class="fas fa-calendar-plus"></i>-->
<!--            </span>-->
            {{ item.data_emissione | date: 'dd/MM/yyyy'}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(item)'>
          <span>
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i class="fas fa-calendar-plus"></i>-->
<!--            </span>-->
            {{ item.data_accettazione | date: 'dd/MM/yyyy'}}
          </span>
        </td>
        <td (click)='edit(item)'>
          <span class="badge badge-pill px-3 font-14" >{{item.oggetto}}</span>
        </td>

        <td class="align-middle" (click)='edit(item)' *ngIf="hasManager()">
          <span >
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i-feather name="user-check" class="feather-sm"></i-feather>-->
<!--            </span>-->
            {{ item?.agenteObject?.fullName ?? item?.managerObject?.fullName }}
          </span>
        </td>
        <td class="align-middle" (click)='edit(item)' *ngIf="environment.ProgettiAddon['lavorato']">
          <span >
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i class="fas fa-euro-sign"></i>-->
<!--            </span>-->
            {{ item.lavorato }}
          </span>
        </td>
        <td class="align-middle" *ngFor="let campo of environment.ProgettiAddon['CampiAggiuntiviLista']" >
          <ng-container *ngFor="let oggetto of campo.oggetti">
              <span [style]="campo.style" [class]="campo.class" >
                <span *ngIf="campo.icon" class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i class="fas" [ngClass]="campo.icon"></i>
                </span>
                {{ campo.type == 'boolean' || campo.type == 'date' ? '' : item[oggetto] }}
                <span *ngIf="campo.type == 'boolean'" [class.text-danger]="!item[oggetto]" [class.text-success] = "item[oggetto]" >
                  <i *ngIf="campo.type == 'boolean'" [class.far] ="!item[oggetto]" [class.fa-times-circle] ="!item[oggetto]" [class.fas] ="item[oggetto]" [class.fa-check-circle] ="item[oggetto]" ></i>
                </span>
                 <span *ngIf="campo.type == 'date'" >
                  {{ item[oggetto] | date: 'dd/MM/yyyy' }}
                 </span>
              </span>

          </ng-container>

        </td>
        <td class="align-middle" *ngIf="permission.isPermitted('gestione-progetti')">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2" (click)='edit(item)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="item.enabled" href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
            (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!item.enabled" href="javascript:void(0)" ngbTooltip="Elimina Definitivamente" class="link font-16 text-danger font-weight-bold"
            (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!item.enabled" ngbTooltip="Riabilita" href="javascript:void(0)" class="link font-16 text-orange font-weight-bold"
            (click)='renew(item)'>
            <i-feather name="plus" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="environment.ProgettiAddon['gestore'] && !item?.gestoreObject && permission.isntOperativeRoles(['AG', 'K'])" ngbTooltip="Prendi in Carico" href="javascript:void(0)" class="link font-16 text-orange font-weight-bold"
             (click)='PrendiInCarico(item)'>
            <i-feather name="user" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
